"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateMonitorForm = void 0;
var ValidateMonitorForm = function (payload, currentLanguage) {
    if (!payload.category) {
        return {
            message: "required",
            field: "category",
            status: "error",
        };
    }
    else if (JSON.parse(payload.name)[currentLanguage] === "") {
        return {
            message: "required",
            field: "name",
            status: "error",
        };
    }
    return {
        message: "success",
        field: "",
        status: "success",
    };
};
exports.ValidateMonitorForm = ValidateMonitorForm;
